var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows6D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_x5F_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M435.4,252.6c-2.4-3.7-4-6.6-8-9c-5-3-10-4.5-15.9-5.2c-4.8-0.6-10-0.1-14.9-0.4c-2.6-0.1-12.4,0.1-13-2.8 c-1.1-5.7,10.6-3,13-2.7c4.6,0.6,9.4,1.4,13.9,2.3c9.2,1.8,20.5,5.6,24.7,15.3c0.4,0.9,0.9,2,0.4,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M277.4,252.6c2.4-3.7,4-6.6,8-9c5-3,10-4.5,15.9-5.2c4.8-0.6,10-0.1,14.9-0.4c2.6-0.1,12.4,0.1,13-2.8 c1.1-5.7-10.6-3-13-2.7c-4.6,0.6-9.4,1.4-13.9,2.3c-9.2,1.8-20.5,5.6-24.7,15.3c-0.4,0.9-0.9,2-0.4,2.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows6D);
export default __webpack_public_path__ + "static/media/eyebrows_6d.0a8bf037b9ffcbb11291f01123fa86e8.svg";
export { ForwardRef as ReactComponent };